import {
  getCrmSteps,
  getKanbanCardsList,
  updateOneLid,
  getOneLid,
  getAllProducts,
  addNewLid,
} from '../../api/kanban'

export default {
  UPDATE_ONE_LID(_, data) {
    return new Promise((resolve, reject) => {
      updateOneLid(data)
        .then(response => {
          resolve(response)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },
  FETCH_ONE_LID({ commit }, id) {
    return new Promise((resolve, reject) => {
      getOneLid(id)
        .then(response => {
          commit('SET_LID', response.data)
          resolve(response)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },
  FETCH_KANBAN_CARDS_LIST({ commit }, query) {
    return new Promise((resolve, reject) => {
      getKanbanCardsList(query)
        .then(response => {
          commit('SET_KANBAN_CARDS_LIST', response.data)
          resolve(response)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },
  FETCH_CRM_STEPS({ commit }) {
    return new Promise((resolve, reject) => {
      getCrmSteps()
        .then(response => {
          commit('SET_CRM_STEPS', response.data)
          resolve(response)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },
  ADD_NEW_LID(_, payload) {
    const reqObj = payload
    reqObj.from_site = true
    return new Promise((resolve, reject) => {
      addNewLid(reqObj)
        .then(response => {
          resolve(response)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },
  FETCH_PRODUCTS_LIST({ commit }, payload) {
    return new Promise((resolve, reject) => {
      getAllProducts(payload)
        .then(response => {
          commit('SET_PRODUCTS_LIST', response.data)
          resolve(response)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },
  // ADD_NEW_PRODUCT(_, payload) {
  //   return new Promise((resolve, reject) => {
  //     addOneProduct(payload)
  //       .then(response => {
  //         resolve(response)
  //       }).catch(error => {
  //         console.log(error)
  //         reject(error)
  //       })
  //   })
  // },
}
